import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FloorEffects } from './floor.effects';
import { floorsReducer } from './floor.reducer';

// ============================================================================
// FLOOR STORE MODULE
// ============================================================================
// Note: We will step away from using this module in the future, so don't
// use this module or build upon it anymore.
// ============================================================================

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('floors', floorsReducer), EffectsModule.forFeature([FloorEffects])],
  providers: [],
})
export class FloorStoreModule {}
